<template>
    <div>
        <v-toolbar class="glass rounded-lg" flat>
            <v-toolbar-title>
               <span v-if="allproducts">Our Products</span>
               <span> {{ formTitle }}</span>
            </v-toolbar-title>
            <v-spacer/>
            <v-btn v-if="allproducts" color="primary" @click="allproducts = false">
                Add New
            </v-btn>
            <v-btn v-else color="success" outlined @click="allproducts = true">
                Back to Products
            </v-btn>
        </v-toolbar>

        <v-card outlined v-if="allproducts">
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="$page.props.products"
                >
                    <template v-slot:item.preview_image="{ item }">
                        <img
                            :src="item.preview_image"
                            height="90px"
                            class="ma-1 rounded-lg"
                            alt=""
                        />
                    </template>

                    <template v-slot:item.is_available="{ item }">
                       <v-switch
                            inset
                            v-model="item.is_available"
                            :true-value="1"
                            :false-value="0"
                            disabled
                        />
                    </template>

                    <template v-slot:item.is_featured="{ item }">
                        <v-switch
                            inset
                            v-model="item.is_featured"
                            :true-value="1"
                            :false-value="0"
                            disabled
                        />
                    </template>


                    <template v-slot:item.actions="{ item }">
                        <div class="d-flex">
                            <v-btn class="mx-1" small color="success" @click="editProduct(item)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn class="mx-1" small color="error" @click="deleteProduct(item)">
                                <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <v-card outlined v-else>
            <v-form @submit.prevent="addEditProduct">
                <v-card-text>
                    <v-row>
                        <v-col>


                            <v-text-field
                                outlined
                                dense
                                v-model="form.name"
                                label="Product Name"
                            />

                            <v-autocomplete
                                :items="$page.props.categories"
                                multiple
                                item-text="title"
                                item-value="id"
                                outlined
                                dense
                                v-model="form.categories"
                                label="Product Categories"
                            />

                            <v-textarea
                                outlined
                                dense
                                v-model="form.preview_text"
                                label="Preview Text"
                                rows="3"

                            />

                            <v-text-field
                                outlined
                                dense
                                v-model="form.price"
                                label="Product Price"
                                hint="You can leave blank if not applicable"
                            />

                          <div class="d-flex justify-space-between px-2">
                              <v-switch
                                  inset
                                  :true-value="1"
                                  :false-value="0"
                                  label="Is Available"
                                  v-model="form.is_available"
                              />

                              <v-switch
                                  inset
                                  :true-value="1"
                                  :false-value="0"
                                  label="Is Featured"
                                  v-model="form.is_featured"
                              />
                          </div>
                        </v-col>
                        <v-col>
                            <v-file-input
                                v-model="form.preview_image"
                                label="Product Image"
                                prepend-icon=""
                                prepend-inner-icon="mdi-camera"
                                outlined
                                class=""
                                dense
                                :error-messages="$page.props.errors.preview_image"
                                accept="image/png  | Width 1024 by 768"
                                :rules="[value => !value || value.size < 2000000 || 'Preview Image size should be less than 2 MB!',]"
                                hint="Only .jpg or .png are allowed"
                            />
                            <img
                                :src="previewFile(form.preview_image)"
                                height="100px"
                                class="ml-1"
                                alt=""
                            />
                        </v-col>
                    </v-row>

                    <h3 class="mb-3 mt-5">
                        Product Details
                    </h3>

                    <editor
                        v-model="form.details"
                        api-key="14yypo7x0g8259wulfr1f05ehujo1f8l2ktu3qvwxdmhleur"
                        :plugins="myPlugins"
                        :toolbar ="myToolbar"
                        :init="myInit"
                        placeholder="Product additional details"
                    ></editor>
                </v-card-text>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn @click="close" depressed outlined color="warning" class="mx-1">
                        Cancel
                    </v-btn>

                    <v-btn type="submit" depressed   color="success" class="mx-1">
                        Submit
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </div>
</template>

<script>
import AdminLayout from "../AdminLayout";
import Editor from '@tinymce/tinymce-vue'
import '../../tinymce/tinymce.min'
import '../../tinymce/icons/default/icons.min'
import '../../tinymce/themes/silver/theme.min'
import '../../tinymce/skins/ui/oxide/skin.min.css'
import '../../tinymce/skins/ui/oxide/content.min.css'
import '../../tinymce/skins/content/default/content.min.css'
import '../../tinymce/plugins/lists/plugin.min'
import '../../tinymce/plugins/wordcount/plugin.min'
import '../../tinymce/plugins/link/plugin.min'
import '../../tinymce/plugins/paste/plugin.min'
import '../../tinymce/plugins/help/plugin.min'
export default {
    name: "Index",
    layout:AdminLayout,

    components:{
        Editor
    },
    data(){
        return {
            allproducts:true,
            form:this.$inertia.form({
                id:null,
                name:null,
                preview_image:null,
                preview_text:null,
                price:null,
                details:null,
                is_available:0,
                is_featured:0,
                categories:null,
            }),
            headers:[
                {text:'Product Name', value:'name'},
                {text:'Image',        value:'preview_image'},
                {text:'Featured',     value:'is_featured'},
                {text:'Available',    value:'is_available'},
                {text:'Actions',      value:'actions',sortable:false},
            ],

            myToolbar: 'undo redo | formatselect | bold italic backcolor | \\\n' +
                '           alignleft aligncenter alignright alignjustify | \\\n' +
                '           bullist numlist outdent indent | removeformat',
            myPlugins: "lists link paste  help wordcount",
            myInit: {
                height:400,
                menubar: false ,
            },
        }
    },

    computed:{

        formTitle(){

            if(this.form.id){
                return 'Edit '+this.form.name+ ' Product'
            }else{
                return 'New Product'
            }
        }
    },

    methods:{
        addEditProduct(){
            this.form.post(route('admin.products.store'),{
                onSuccess:()=>{
                    this.close()
                }
            })
        },

        close(){
            this.form.reset()
            this.dialog = false
        },

        editProduct(product){
            this.form.id              = product.id
            this.form.name            = product.name
            this.form.preview_image   = product.preview_image
            this.form.preview_text   = product.preview_text
            this.form.price           = product.price
            this.form.is_available    = product.is_available
            this.form.is_featured     = product.is_featured
            this.form.details         = product.details
            this.form.categories      = product.categories
            this.allproducts = false
        },

        deleteProduct(product){
            Swal.fire({
                title: 'Are you sure?',
                text: ""+product.name+ " will be deleted!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {

                    this.$inertia.delete(route('admin.products.destroy',product.id),{
                        resetOnSuccess: false,
                        onSuccess: ()=>{
                            Toast.fire({
                                icon: 'success',
                                title: 'Product Deleted!'
                            })
                        }
                    })
                }
            })
        }
    }
}
</script>

<style  >

</style>
